import { useTheme } from "@shopify/restyle";
import React, { useState } from "react";
import Animated, {
  Easing,
  useAnimatedStyle,
  withTiming,
} from "react-native-reanimated";

import { Box } from "../../../../components/primitive";
import { Theme } from "../../../../theme/restyle/theme";

export type ScreenFooterProps = {
  children?: React.JSX.Element | React.JSX.Element[];
  show?: boolean;
  onLayoutChange?: (event: any) => void;
};

export const ScreenFooter = ({
  children,
  show = true,
  onLayoutChange,
}: ScreenFooterProps) => {
  const [layoutWidth, setLayoutWidth] = useState(0);
  const theme = useTheme<Theme>();
  const smBreakPointPxWidth = theme.breakpoints.sm;

  const handleLayoutChange = (event: any) => {
    const { width } = event.nativeEvent.layout;
    setLayoutWidth(width);
    onLayoutChange && onLayoutChange(event);
  };

  const animatedStyle = useAnimatedStyle(() => {
    return {
      opacity: withTiming(show ? 1 : 0, { duration: 300, easing: Easing.ease }),
      transform: [
        { translateY: withTiming(show ? 0 : 150, { duration: 400 }) },
      ],
    };
  }, [show]);

  return (
    <Animated.View
      style={[
        {
          position: "absolute",
          backgroundColor: "none",
          bottom: 0,
          zIndex: 10000,
          width: "100%",
          borderRadius: 24,
        },
        animatedStyle,
      ]}
    >
      <Box
        paddingHorizontal={layoutWidth >= smBreakPointPxWidth ? 6 : 0}
        onLayout={handleLayoutChange}
      >
        <Box
          padding={6}
          shadowOffset={{ width: 0, height: 4 }}
          shadowOpacity={0.08}
          shadowRadius={16}
          elevation={2}
          shadowColor={"black"}
          borderTopLeftRadius={"6"}
          borderTopRightRadius="6"
          backgroundColor="surface-primary"
          width="100%"
        >
          {children}
        </Box>
      </Box>
    </Animated.View>
  );
};
